import * as React from 'react';
import { useIntl } from 'react-intl';

import { scale030 } from '@xing-com/tokens';

import { SkeletonPillShape } from '..';
import type { SkeletonProgressBarProps } from '..';

export const SkeletonProgressBar = React.forwardRef<
  HTMLDivElement,
  SkeletonProgressBarProps
>(({ className, ...props }, forwardedRef): JSX.Element => {
  const intl = useIntl();

  return (
    <SkeletonPillShape
      aria-busy="true"
      aria-label={intl.formatMessage({
        id: 'XDS_SKELETON_GENERIC_A11Y',
        defaultMessage: 'Loading',
      })}
      className={className}
      data-xds="SkeletonProgressBar"
      height={scale030}
      ref={forwardedRef}
      role="status"
      {...props}
    />
  );
});

SkeletonProgressBar.displayName = 'SkeletonProgressBar';
